// Import the functions you need from the SDKs you need
import 'firebase/compat/database'
import firebase from 'firebase/compat/app';


const firebaseConfig = {
  apiKey: "AIzaSyB3__dPyoHbDit5RGpWStPP22KnjlqJX68",
  authDomain: "portfolio-b155c.firebaseapp.com",
  projectId: "portfolio-b155c",
  storageBucket: "portfolio-b155c.appspot.com",
  messagingSenderId: "210472899357",
  appId: "1:210472899357:web:b78cfb3ea74aea2969c7f4",
  measurementId: "G-T2DH2ZCPF5"
};

firebase.initializeApp(firebaseConfig);
export const dataRef=firebase.database();
export default firebase;